import React from 'react';
import Icon from '../../../components/openplay/OpenPlayIcon';

const MapViewToggle = ({ currentView, onToggle, showLabels = true }) => {
  return (
    <div className="flex items-center gap-1 p-1 rounded-lg bg-card shadow-elevation-2 border border-border">
      <button
        onClick={() => onToggle('map')}
        className={`flex items-center gap-2 px-3 py-2 rounded-md font-medium transition-smooth touch-target ${
          currentView === 'map'
            ? 'bg-primary text-primary-foreground shadow-elevation-1'
            : 'text-muted-foreground hover:text-foreground'
        }`}
        type="button"
      >
        <Icon name="MapIcon" size={20} />
        {showLabels ? <span className="text-sm">지도</span> : <span className="sr-only">지도</span>}
      </button>
      <button
        onClick={() => onToggle('list')}
        className={`flex items-center gap-2 px-3 py-2 rounded-md font-medium transition-smooth touch-target ${
          currentView === 'list'
            ? 'bg-primary text-primary-foreground shadow-elevation-1'
            : 'text-muted-foreground hover:text-foreground'
        }`}
        type="button"
      >
        <Icon name="ListBulletIcon" size={20} />
        {showLabels ? <span className="text-sm">리스트</span> : <span className="sr-only">리스트</span>}
      </button>
    </div>
  );
};

export default MapViewToggle;
